import { render, staticRenderFns } from "./Template2.vue?vue&type=template&id=55ab79c9&scoped=true"
import script from "./Template2.vue?vue&type=script&lang=js"
export * from "./Template2.vue?vue&type=script&lang=js"
import style0 from "./Template2.vue?vue&type=style&index=0&id=55ab79c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ab79c9",
  null
  
)

export default component.exports